import { Component, effect, inject, OnInit } from '@angular/core';
import { Menu } from 'primeng/menu';
import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { PendingOrdersService } from '../../../../core/services/pending-orders.service';
import { I18nService } from '../../../../shared/services/i18n.service';

@Component({
  selector: 'app-nav-menu',
  imports: [
    Menu
  ],
  templateUrl: './nav-menu.html',
  styleUrl: './nav-menu.scss'
})
export class NavMenu implements OnInit {
  menuItems: MenuItem[] = [];

  private translate = inject(TranslateService);
  private pendingOrders = inject(PendingOrdersService);
  private i18n = inject(I18nService);

  constructor() {
    // Update badge whenever count changes
    effect(() => {
      const count = this.pendingOrders.count();
      this.updateMenu(count);
    });
  }

  ngOnInit() {
    this.pendingOrders.startPolling();
    this.updateMenu(this.pendingOrders.count());
    this.translate.onLangChange.subscribe(() => {
      this.updateMenu(this.pendingOrders.count());
    });
  }

  updateMenu(pendingCount = 0) {
    const adminLink = (path: string): MenuItem => ({
      routerLink: [this.i18n.generateUrlWithLang(`admin/${path}`)],
      routerLinkActiveOptions: { exact: true },
    });

    this.menuItems = [
      {
        label: this.translate.instant('admin.nav.groups.main'),
        items: [
          {
            label: this.translate.instant('app.nav.store'),
            icon: 'pi pi-shop',
            routerLink: [this.i18n.generateUrlWithLang('')],
            routerLinkActiveOptions: { exact: true },
          },
          {
            label: this.translate.instant('app.nav.dashboard'),
            icon: 'pi pi-home',
            ...adminLink('dashboard'),
          },
          {
            label: this.translate.instant('app.nav.pending_review'),
            icon: 'pi pi-clipboard',
            ...adminLink('orders-acceptance'),
            badge: pendingCount > 0 ? String(pendingCount) : undefined,
            badgeStyleClass: 'p-badge-warning',
            styleClass: 'nav-pending-review',
          },
        ],
      },
      {
        label: this.translate.instant('admin.nav.groups.sales'),
        items: [
          {
            label: this.translate.instant('app.nav.orders'),
            icon: 'pi pi-receipt',
            ...adminLink('orders'),
          },
          {
            label: this.translate.instant('app.nav.users'),
            icon: 'pi pi-users',
            ...adminLink('users'),
          },
        ],
      },
      {
        label: this.translate.instant('admin.nav.groups.catalog'),
        items: [
          {
            label: this.translate.instant('app.nav.catalog'),
            icon: 'pi pi-folder',
            ...adminLink('catalog'),
          },
          {
            label: this.translate.instant('app.nav.categories'),
            icon: 'pi pi-tags',
            ...adminLink('categories'),
          },
          {
            label: this.translate.instant('admin.nav.product_groups'),
            icon: 'pi pi-th-large',
            ...adminLink('product-groups'),
          },
          {
            label: this.translate.instant('app.nav.pod-products'),
            icon: 'pi pi-box',
            ...adminLink('pod-products'),
          },
          {
            label: this.translate.instant('app.nav.styles'),
            icon: 'pi pi-sparkles',
            ...adminLink('styles'),
          },
        ],
      },
      {
        label: this.translate.instant('admin.nav.groups.content'),
        items: [
          {
            label: this.translate.instant('app.nav.reviews'),
            icon: 'pi pi-star',
            ...adminLink('reviews'),
          },
          {
            label: this.translate.instant('app.nav.blog'),
            icon: 'pi pi-book',
            ...adminLink('blog'),
          },
          {
            label: this.translate.instant('admin.nav.link_generator'),
            icon: 'pi pi-link',
            ...adminLink('link-generator'),
          },
        ],
      },
    ];
  }
}
